module.exports = __webpack_public_path__ + "media/images/signin-bg-0f76947768f1868701ef0a1142e5ad91.png";